'use client';

import { useRef } from 'react';
import classNames from 'classnames';
import ReactTransition from 'react-transition-group/Transition';

export type TransitionProps = {
  in: boolean;
  className: string;
  enterCls?: string;
  enterActiveCls?: string;
  exitCls?: string;
  exitActiveCls?: string;
  children?: React.ReactNode;
  enterTimeout?: number;
  exitTimeout?: number;
  unmountOnExit?: boolean;
};

export const Transition = (props: TransitionProps) => {
  const {
    className,
    in: inProp,
    enterCls,
    enterActiveCls,
    exitCls,
    exitActiveCls,
    children,
    enterTimeout = 0,
    exitTimeout = 300,
    unmountOnExit = false,
  } = props;
  const nodeRef = useRef(null);

  return (
    <ReactTransition
      unmountOnExit={unmountOnExit}
      appear={false}
      nodeRef={nodeRef}
      in={inProp}
      timeout={{ appear: 0, enter: enterTimeout, exit: exitTimeout }}
    >
      {state => (
        <div
          ref={nodeRef}
          className={classNames(className, {
            [`${enterCls}`]: enterCls && state === 'entering',
            [`${enterActiveCls}`]: enterActiveCls && state === 'entered',
            [`${exitCls}`]: exitCls && state === 'exiting',
            [`${exitActiveCls}`]: exitActiveCls && state === 'exited',
          })}
        >
          {children}
        </div>
      )}
    </ReactTransition>
  );
};
